import { DispatchLoading, DispatchType, ResponseValid } from 'domain/utils/ReactUtils'
import { _UserData, UserDataBaseEnum } from 'base/src/infra/storage/localStorage';
import { UsuarioResponse } from 'domain/types/usuario/usuarioResponse';
import { AppThunk } from 'base/src/utils/reducerUtil';
import { PerfilService } from '../../../services/perfil/perfilService';
import { ALTERAR_PERFIL } from '../../../types/authPerfil/authPerfil';

const _PerfilService = new PerfilService();

export function AlterarPerfil(request: FormData): AppThunk {
    return async (dispatch) => {
        dispatch(DispatchLoading(ALTERAR_PERFIL, DispatchType.LOADING, "Aguarde!", undefined,
            () => { dispatch(AlterarPerfil(request)) }))

        const asyncResponse = await _PerfilService.AlterarPerfil(request)
        if (ResponseValid(asyncResponse)) {
            const Usuario = asyncResponse as UsuarioResponse;
            Usuario.Token = _UserData.Get<string>(UserDataBaseEnum.Token)

            _UserData.Register(Usuario);

            dispatch({
                payload: Usuario,
                type: ALTERAR_PERFIL
            })
        }
    }
}






